import { DateRange } from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';
import { getTodayEndDate } from '../Calendar/helpers';
import { DateTimeRange, TimePeriodUnit } from '../types';

export function getDateRange(value: DateTimeRange | null): DateRange<Dayjs> {
  if (value == null) {
    return [null, null];
  }

  if (value.type === 'absolute') {
    return [value.startAfter, value.endBefore];
  }

  if (value.type === 'since') {
    return [value.startAfter, getTodayEndDate()];
  }

  if (value.type === 'last') {
    const today = getTodayEndDate();
    let lastDate = value.value
      ? today.clone().subtract(value.value, value.unit).startOf('day')
      : null;

    if (lastDate) {
      lastDate =
        value.unit === TimePeriodUnit.Month
          ? lastDate.startOf('month').tz()
          : value.unit === TimePeriodUnit.Week
          ? lastDate.startOf('week').tz()
          : lastDate;
    }

    return [lastDate, today];
  }

  return [null, null];
}
